export default "__VITE_ASSET__5c80ba96__"